<template>
  <div class="asc-navigation-manager">
    <asc-primary-navbar
      :collapsed="isCollapsed"
      :on-size-change="handleSizeChange"
      :router="router"
      :feature-flags="featureFlags"
      :user-roles="userRoles"
      :user-airlines="userAirlines"
      :user-permissions="userPermissions"
    ></asc-primary-navbar>
    <asc-top-navbar
      :collapsed="isCollapsed"
      :notifications="notifications"
      :on-size-change="handleSizeChange"
      :on-manage-gaf="onManageGaf"
      :on-log-out="onLogOut"
      :profile="profile"
      :feature-flags="featureFlags"
      :global-filter-text="globalFilterText"
      :global-filter-tooltip="globalFilterTooltip"
      :global-filter-active="globalFilterActive"
      :global-filter-enabled="globalFilterEnabled"
      :global-filter-disabled="globalFilterDisabled"
      :global-filter-visible="globalFilterVisible"
    ></asc-top-navbar>
  </div>
</template>

<script>
import AscTopNavbar from './AscTopNavbar'
import AscPrimaryNavbar from './AscPrimaryNavbar'

export default {
  name: 'AscNavigationManager',

  components: {
    AscTopNavbar,
    AscPrimaryNavbar,
  },

  props: {
    notifications: {
      type: Object,
      default: () => {
        return {
          primaryLinks: [],
          secondaryLinks: [],
        }
      },
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    onSizeChange: {
      type: Function,
      default: () => {},
    },
    onManageGaf: {
      type: Function,
      default: () => {},
    },
    router: {
      type: Object,
      default: () => {},
    },
    featureFlags: {
      type: Object,
      default: () => {},
    },
    globalFilterText: {
      type: String,
      default: '',
    },
    globalFilterTooltip: {
      type: String,
      default: '',
    },
    globalFilterActive: {
      type: Boolean,
      default: false,
    },
    globalFilterEnabled: {
      type: Boolean,
      default: false,
    },
    globalFilterDisabled: {
      type: Boolean,
      default: false,
    },
    globalFilterVisible: {
      type: Boolean,
      default: false,
    },
    onLogOut: {
      type: Function,
      default: () => {},
    },
    profile: {
      type: Object,
      default: () => {},
    },
    userRoles: {
      type: Array,
      default: () => [],
    },
    userPermissions: {
      type: Array,
      default: () => [],
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isCollapsed: this.collapsed,
    }
  },

  watch: {
    collapsed(newValue) {
      this.isCollapsed = newValue
    },
  },

  methods: {
    handleSizeChange(value) {
      this.isCollapsed = value
      if (this.onSizeChange) {
        this.onSizeChange()
      }
    },
  },
}
</script>
